import type { LoadedInfo } from 'owa-sxsdata';

export const PreviewLoadOrErrorEvent = 'PreviewLoadOrError';
export const PreviewLoadInProgressEvent = 'PreviewLoadInProgress';
export const AnimationEndEvent = 'AnimationEnd';
export interface LoadOrErrorEventData {
    loadedInfo?: LoadedInfo;
    errorMessage: string;
    error?: Error;
}
